<div *ngIf="reportType == 'VeryBriefly-CreditNote'">
    <div class="container" id="print-section">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th colspan="2">Vivek Saptahik</th>
                    <th colspan="5">Advt. Credit Note Register</th>
                    <th colspan="1">Date {{currentDate | date:'dd-MM-yyyy'}}</th>
                </tr>
                <tr>
                    <th colspan="2" style="font-size: small;">VeryBriefly-Officer</th>
                    <th colspan="5"></th>
                    <th colspan="1" style="font-size: small;">{{startDate | date:'dd-MM-yyyy'}} To {{endDate | date:'dd-MM-yyyy'}}</th>
                </tr>
                <tr>
                    <th colspan="2" style="font-size: 14px;">Representative<br>Name</th>
                    <th colspan="2" style="font-size: 14px;">Office Rep <br> Name</th>
                    <th style="text-align: center;font-size: 14px;" colspan="3">Credit Note Amount</th>
                    <th style="text-align: center;font-size: 14px;" colspan="1">Total</th>
                </tr>
                <tr>
                    <th colspan="4"></th> 
                    <th style="text-align: center;font-size: 14px;">TDS</th>
                    <th style="text-align: center;font-size: 14px;">Other</th>
                    <th colspan="2"></th> 
                </tr>
            </thead>

            <tbody *ngFor="let data of CreditNoteVBFormBeans; let i = index">
                <!-- Office Representative Header -->
                <tr style="background-color: #f8f9fa;">
                    <td colspan="2" style="font-weight: bold; font-size: 16px;">Office Representative</td>
                    <td colspan="6" style="font-weight: bold; font-size: 16px;">{{data.office_rep}}</td>
                </tr>

                <!-- Loop through each grouped representative -->
                <ng-container *ngFor="let rep of data.grouped_rep_data; let j = index">
                    <!-- Representative Data Row (Grouped/Summed) -->
                    <tr>
                        <td colspan="2" style="font-size: 15px;">{{rep.rep_name}}</td>
                        <td colspan="2" style="font-size: 15px;">{{data.office_rep}}</td>
                        <td style="text-align: end;font-size: 15px;" colspan="1">
                            {{(rep.tds_amt * 1).toFixed(2)}}
                        </td>
                        <td style="text-align: end;font-size: 15px;" colspan="1">
                            {{(rep.other_credit_amt * 1).toFixed(2)}}
                        </td>
                        <td style="text-align: end;font-size: 15px;" colspan="2">
                            {{(rep.credit_amt * 1).toFixed(2)}}
                        </td>
                    </tr>
                    
                    <!-- Representative Total (after each rep) -->
                    <tr style="background-color: #e3f2fd;">
                        <td colspan="2" style="font-weight: bold; text-align: end; font-size: 14px;">
                            Rep Total:
                        </td>
                        <td colspan="2" style="font-weight: bold; font-size: 14px;">
                            {{rep.rep_name}}
                        </td>
                        <td style="font-weight: bold; text-align: end; font-size: 14px;" colspan="1">
                            {{(rep.tds_amt * 1).toFixed(2)}}
                        </td>
                        <td style="font-weight: bold; text-align: end; font-size: 14px;" colspan="1">
                            {{(rep.other_credit_amt * 1).toFixed(2)}}
                        </td>
                        <td style="font-weight: bold; text-align: end; font-size: 14px;" colspan="2">
                            {{(rep.credit_amt * 1).toFixed(2)}}
                        </td>
                    </tr>
                </ng-container>

                <!-- Office Representative Total (after all reps) -->
                <tr style="background-color: #f8f9fa; border-top: 2px solid #080808;">
                    <td colspan="2" style="font-weight: bold; text-align: end; font-size: 16px;">
                        Office Total:
                    </td>
                    <td colspan="2" style="font-weight: bold; font-size: 16px;">
                        {{data.office_rep}}
                    </td>
                    <td style="font-weight: bold; text-align: end; font-size: 16px;" colspan="1">
                        {{(data.tds_amt * 1).toFixed(2)}}
                    </td>
                    <td style="font-weight: bold; text-align: end; font-size: 16px;" colspan="1">
                        {{(data.other_credit_amt * 1).toFixed(2)}}
                    </td>
                    <td style="font-weight: bold; text-align: end; font-size: 16px;" colspan="2">
                        {{(data.total * 1).toFixed(2)}}
                    </td>
                </tr>
                
                <!-- Spacing row between office representatives -->
                <tr style="height: 10px;">
                    <td colspan="8" style="border: none; background-color: white;"></td>
                </tr>
            </tbody>

            <!-- Grand Total -->
            <tbody>
                <tr>
                    <td colspan="2" style="text-align: end; font-weight: bold; background-color: #e9ecef; color: #080808; border-top: 3px solid #080808; font-size: 18px;">
                        Grand
                    </td>
                    <td colspan="2" style="text-align: end; font-weight: bold; background-color: #e9ecef; color: #080808; border-top: 3px solid #080808; font-size: 18px;">
                        Total:
                    </td>
                    <td colspan="1" style="text-align: end; font-weight: bold; background-color: #e9ecef; color: #080808; border-top: 3px solid #080808; font-size: 18px;">
                        {{(CreditadvtOffVBMTotalTDS * 1).toFixed(2)}}
                    </td>
                    <td colspan="1" style="text-align: end; font-weight: bold; background-color: #e9ecef; color: #080808; border-top: 3px solid #080808; font-size: 18px;">
                        {{(CreditadvtOffVBMTotalOther * 1).toFixed(2)}}
                    </td>
                    <td colspan="2" style="text-align: end; font-weight: bold; background-color: #e9ecef; color: #080808; border-top: 3px solid #080808; font-size: 18px;">
                        {{(CreditadvtOffVBMTotal * 1).toFixed(2)}}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div style="margin-left: 80%; margin-bottom: 2%;">
        <button 
            class="noPrint" 
            style="margin: 2% 2% 0 2%;" 
            (click)="exportExcel('Datewise_Subscription_Report')" 
            mat-raised-button 
            color="primary">
            Export
        </button>
        
        <button class="no-print" style="margin-top: 2%; margin-right: 2%" 
            (click)="printPageA4Portrait()" mat-raised-button color="primary">
            Print
        </button>
        
        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div>